/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import PropertyDetailsView from "../../components/OverallProperties/PropertyDetails/PropertyDetailsView";
import RoomBooking from "../../components/OverallProperties/RoomBooking/RoomBooking";
import BookingList from "../../components/OverallProperties/BookingList/BookingList";
import BookingTransaction from "../../components/OverallProperties/BookingTransaction/BookingTransaction";
import OverallMMC from "../../components/OverallProperties/MMC/OverallMMC";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import BookingView from "../Bookings/BookingView";
import { checkPermission } from "../redux/api/PermissionManager";

const PropertyDetails = () => {
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const { paginationData, setpaginationData } = useGlobalContext();
  const category_id = location?.state?.category_id;
  const property_id = location?.state?.id;
  const sub_tabs = location?.state?.sub_tabs;
  const from_date = location?.state?.from_date;
  const to_date = location?.state?.to_date;
  console.log("category_id", category_id, location.state);
  const [service_id, setService_id] = useState(
    paginationData?.[path]?.service_id ?? "",
  );
  const [services, setServices] = useState([]);
  const [subTabs, setsubTabs] = useState(
    sub_tabs ? sub_tabs : (paginationData?.[path]?.subTabs ?? 1),
  );

  const navigate = useNavigate();
  useEffect(() => {
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], service_id: service_id, subTabs: subTabs },
    }));
  }, [subTabs]);

  // useEffect(() => {
  //   if (location?.state?.sub_tabs) {
  //     const { sub_tabs, ...restState } = location.state;

  //     console.log("val--->sub_tabs", sub_tabs, "restState", restState);
  //     navigate(location.pathname, {
  //       replace: true,
  //       state: restState,
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (category_id) {
      getServices();
    }
  }, [category_id]);

  const getServices = async () => {
    const res = await get(`${URLS.HOTELCATEGORIES}${category_id}/services/`);
    console.log("service list", res);
    if (res?.status === "success") {
      setServices(res?.data);
    }
  };
  console.log("services", service_id);
  return (
    <div>
      <Topbar
        header={"Properties"}
        subHead={"Overall Properties"}
        back={true}
      />
      <div className="d-flex ac-js gap-4">
        <p
          onClick={() => {
            setsubTabs(1);
          }}
          className={`${
            subTabs === 1 ? "prim-btn" : "sec"
          } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 pointer`}
        >
          Property Detail
        </p>
        {services?.map((service, ind) => {
          if (service?.name !== "Room Booking") return null;
          let currentTab = service?.name === "Room Booking" ? 2 : "";
          return (
            <p
              onClick={() => {
                if (service?.name !== "Room Booking") return;
                setsubTabs(service?.name === "Room Booking" ? 2 : "");
                setService_id(service?.id);
              }}
              className={`${
                subTabs === currentTab ? "prim-btn" : "sec"
              } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  ms-4 pointer`}
            >
              {service?.display_name}
            </p>
          );
        })}
        {checkPermission("CAN-LIST-BOOKINGS") && (
          <p
            onClick={() => {
              setsubTabs(5);
            }}
            className={`${
              subTabs === 5 ? "prim-btn" : "sec"
            } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  ms-4 pointer`}
          >
            Booking List
          </p>
        )}
        <p
          onClick={() => {
            setsubTabs(6);
          }}
          className={`${
            subTabs === 6 ? "prim-btn" : "sec"
          } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  ms-4 pointer`}
        >
          Booking Transaction
        </p>
        {(checkPermission("CAN-LIST-MMC_CANCELLATION") ||
          checkPermission("CAN-LIST-MMC_SUSPENDED") ||
          checkPermission("CAN-LIST-MMC_TRANSACTION")) && (
          <p
            onClick={() => {
              setsubTabs(7);
            }}
            className={`${
              subTabs === 7 ? "prim-btn" : "sec"
            } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  ms-4 pointer`}
          >
            MMC
          </p>
        )}
      </div>
      {subTabs === 1 && <PropertyDetailsView />}
      {subTabs === 2 && <RoomBooking service_id={service_id} />}
      {subTabs === 5 && (
        <BookingView property_id={property_id} sub_tabs={sub_tabs} />
      )}
      {subTabs === 6 && (
        <BookingTransaction
          property_id={property_id}
          sub_tabs={sub_tabs}
          from_date={from_date}
          to_date={to_date}
        />
      )}
      {subTabs === 7 && <OverallMMC />}
    </div>
  );
};

export default PropertyDetails;
